import React, { useEffect, useState } from 'react'

import {
    BrowserRouter as Router,
    Switch,
    Routes,
    Route,
    useLocation
  } from "react-router-dom";

import {Grid, CircularProgress, Box} from '@mui/material'
import { useDispatch, useSelector } from 'react-redux'

import useStyles from './styles.js'
import { isAdminUser, isReaderUser } from '../../actions/auth.js';
import Lives from './lives/Lives.js';
import FormLive from './lives/form/FormLive.js';

const MainContainer = () => {
    const classes = useStyles();

    const location = useLocation();
    const dispatch = useDispatch()

    const [currentId, setCurrentId] = useState(null)

    useEffect(() => {
        setCurrentId(null)
    }, [location])

    return (
        <Box className='display-grid'>
            {location.pathname==="/divers/lives" && <FormLive />}
            {location.pathname==="/divers/lives" && <Lives setCurrentId={setCurrentId}/>}
        </Box>
        )
}

export default MainContainer